var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__figure"}),_c('p',{staticClass:"loader__label"},[_vm._v("Emarketing")])])])
}]

export { render, staticRenderFns }